import { render, staticRenderFns } from "./TLDBreakDown.vue?vue&type=template&id=a3218dd0&"
import script from "./TLDBreakDown.vue?vue&type=script&lang=js&"
export * from "./TLDBreakDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports